<div *ngIf="alert" [class]="'dna-alert dna-alert--' + alert.type" (click)="dismiss()">
  <span class="dna-alert-text">{{ alert.text }}</span>
  <span class="dna-alert-close material-icons">close</span>
</div>
